import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private _theme = signal<string>('');
  theme = this._theme.asReadonly();

  loadTheme() {
    let loaded = false;
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const theme = localStorage.getItem('theme');
    const matchesTheme = theme ? theme === 'dark' : darkModeMediaQuery.matches;

    this.setTheme(matchesTheme ? 'dark' : 'light');

    darkModeMediaQuery.addEventListener('change', e => {
      if (loaded === true) this.setTheme(e.matches ? 'dark' : 'light');
    });

    loaded = true;
  }

  toggleTheme() {
    const theme = this._theme() === 'dark' ? 'light' : 'dark';
    this.setTheme(theme);
  }

  setTheme(theme: string) {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-bs-theme', theme);
    this._theme.set(theme);
  }
}
